export function greaterThanEqualMatcherContext(ruleAttr) {
  return function greaterThanEqualMatcher(runtimeAttr) {
    var isGreaterThanEqual = runtimeAttr >= ruleAttr;
    return isGreaterThanEqual;
  };
}